import React from "react";

export default function MiniPuzRow({ rowIndex, row, hiddenWord, positions, positionColors, onCellClick }) {
    const isFoundInPositions = (row, col) => {
        return positions.some(position => position.row === row && position.col === col);
    };

    return (
        <div style={{ display: "flex", gap: "1px" }}>
            {row.map((cell, colIndex) => {
                const cellKey = `${rowIndex}-${colIndex}`;
                const cellColor = positionColors && positionColors[cellKey];
                const isHighlighted = !cellColor && hiddenWord && isFoundInPositions(rowIndex, colIndex);
                const backgroundColor = cellColor || (isHighlighted ? "#ffeb3b" : (cell ? "#fff" : "#f5f5f5"));
                const textColor = (cellColor || isHighlighted) ? "#000" : (cell ? "#000" : "#999");

                return (
                    <div
                        key={colIndex}
                        onClick={() => onCellClick && onCellClick(rowIndex, colIndex)}
                        style={{
                            width: "24px",
                            height: "24px",
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            fontWeight: "bold",
                            backgroundColor,
                            color: textColor,
                            cursor: onCellClick ? "pointer" : "default"
                        }}
                    >
                        {cell || ""}
                    </div>
                );
            })}
        </div>
    );
}

